interface MirrorIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function MirrorIcon(props: MirrorIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={73}
      height={66}
      viewBox="0 0 73 66"
      className="mirror-icon"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <g data-name="Group 11">
        <g data-name="Polygon 1">
          <path d="M.5 47.213V17.787L31.824 32.5.5 47.213z" />
          <path
            d="M30.648 32.5L1 18.575v27.85L30.648 32.5m2.352 0L0 48V17l33 15.5z"
            fill="#707070"
          />
        </g>
        <g data-name="Polygon 2" fill="#fff">
          <path d="M72.5 17.798v29.404L42.147 32.5 72.5 17.798z" />
          <path
            d="M43.294 32.5L72 46.404V18.596L43.294 32.5M41 32.5L73 17v31L41 32.5z"
            fill="#707070"
          />
        </g>
        <path
          data-name="Line 10"
          fill="none"
          stroke="#707070"
          strokeWidth={3}
          d="M37 0v66"
        />
      </g>
    </svg>
  )
}
